import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { legalEndpoints } from '@/modules/legal/constants';

import { legalQueryKeys } from './queryKeys';

export const useTermsAcceptanceQuery = (tenantId: string | undefined) => {
  return useQuery({
    queryKey: legalQueryKeys.termsAcceptance(tenantId),
    queryFn: tenantId
      ? async () => {
          const { data } = await fetchClient.GET(
            legalEndpoints.termsAcceptance,
            { params: { query: { tenantId } } },
          );
          return data;
        }
      : skipToken,
  });
};
